import { FieldArray } from 'formik';
import React from 'react';
import SmallBlueButton from '@components/common/button/SmallBlueButton';
import MeetingInfo from './MeetingInfo';
import StyledErrorMessage from '@components/common/form/formik/input/StyledErrorMessage';
import { DayOfTheWeek } from '@data/course/courseData';

interface MeetingsInfoProps {
  meetingsLength: number;
  sectionIndex: number;
}

const MeetingsInfo = ({ meetingsLength, sectionIndex }: MeetingsInfoProps) => {
  const meetingIndexes = Array.from(new Array(meetingsLength).keys());

  return (
    <FieldArray
      name={`sections[${sectionIndex}].meetings`}
      render={(arrayHelpers) => (
        <div className='children-spaced'>
          {meetingIndexes.map((meetingIndex) => (
            <div key={meetingIndex} className='bg-white p-4'>
              <MeetingInfo
                meetingIndex={meetingIndex}
                sectionIndex={sectionIndex}
                removeSelf={() => arrayHelpers.remove(meetingIndex)}
                canRemove={meetingsLength > 1}
              ></MeetingInfo>
            </div>
          ))}
          <div className='mb-4'>
            <StyledErrorMessage name={`sections[${sectionIndex}].meetings`}></StyledErrorMessage>
          </div>
          <SmallBlueButton
            text='ADD MEETING'
            onClick={() => arrayHelpers.push({ day: DayOfTheWeek.Monday, time: '00:00' })}
            clickable={meetingsLength < 2}
          />
        </div>
      )}
    />
  );
};

export default MeetingsInfo;
